import {Button, Group, Modal} from '@mantine/core';
import React, {useState} from 'react';

import type {AntibodyFormat} from 'antibodies/AntibodyTypedefs';
import {NdcSpreadsheetComponentFormatType} from 'antibodies/nested-data-creation/spreadsheet-import/constants/AntibodyNestedDataCreationSpreadsheetImportConstants';
import UploadSpreadsheetPane from 'antibodies/nested-data-creation/spreadsheet-import/panes/UploadSpreadsheetPane';
import ModalFooter from 'ui-library/modals/ModalFooter';

interface ProteinCreationSpreadsheetImportModalProps {
  format: AntibodyFormat;
  onClose: () => void;
  startingType: NdcSpreadsheetComponentFormatType;
}

export default function ProteinCreationSpreadsheetImportModal({
  format,
  onClose,
  startingType,
}: ProteinCreationSpreadsheetImportModalProps): JSX.Element {
  const [spreadsheetFile, setSpreadsheetFile] = useState<File | null>(null);

  return (
    <Modal
      title="Add from spreadsheet"
      opened={true}
      onClose={onClose}
      size="xl"
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <UploadSpreadsheetPane
        startingType={startingType}
        spreadsheetFile={spreadsheetFile}
        setSpreadsheetFile={setSpreadsheetFile}
        setSpreadsheetURL={() => {}}
        clearSpreadsheet={() => {
          setSpreadsheetFile(null);
        }}
        columnInferenceErrorMessages={[]}
        isInferringColumns={false}
        selectedAntibodyFormat={format}
      />
      <ModalFooter>
        <Group position="apart">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={true}>Next</Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
}
